export const featuresPagePath = '/features/:categorySlug?/:typeSlug?';
export const featuresPageFragment = 'top';

export const getFeaturesPageUrl = (categorySlug?: string, typeSlug?: string) => {
  let url = featuresPagePath;
  url = url.replace('/:categorySlug?', categorySlug ? `/${categorySlug}` : '');
  url = url.replace('/:typeSlug?', typeSlug ? `/${typeSlug}` : '');

  return url;
};